import { expand } from 'uri-template-lite';
import { apiClient } from '../../common/ApiClient';
import { createApiQueryHook } from '../../common/queryClient/createApiQueryHook';
import { SystemClassifierUrl } from './SystemClassifierUrl';
import { SystemClassifierDto, SystemClassifierFilter } from '../schema';
import { SystemClassifierPageSchema } from '../schema/SystemClassifierSchema';
import { PageRequestParams } from '../../common/queryClient';

const getSystemClassifiers = (
  params: SystemClassifierFilter & PageRequestParams
) =>
  apiClient
    .get<SystemClassifierDto>(expand(SystemClassifierUrl.SEARCH, params))
    .then((response) => SystemClassifierPageSchema.parse(response.data));

export const useSystemClassifiersQuery = createApiQueryHook(
  ['systemClassifiers'],
  getSystemClassifiers
);
